import React from 'react';

export interface KpiCardProps {
  title: string;
  value: number | string;
  trend?: {
    value: number;
    direction: 'up' | 'down';
  };
  average?: string;
  period?: string;
  icon?: string;
  color?: 'primary' | 'success' | 'danger' | 'warning' | 'info';
  footerLink?: {
    href: string;
    text: string;
  };
  largeIcon?: string;        // Background icon class (e.g., 'bi-cart', 'bi-people-fill')
}

export function KpiCard({
  title,
  value,
  trend,
  average,
  period,
  icon,
  color = 'primary',
  footerLink,
  largeIcon,
}: KpiCardProps) {
  const trendIcon = trend?.direction === 'up' ? 'bi-arrow-up' : 'bi-arrow-down';

  return (
    <div className="card kpi-card" data-testid="kpi-card">
      <div className="card-body">
        <div className="kpi-content">
          <div className="kpi-label">{title}</div>
          <div className="kpi-value">{value}</div>
          <div className="kpi-meta">
            {trend && (
              <span className={`kpi-change ${trend.direction === 'up' ? 'positive' : 'negative'}`}>
                <i className={`bi ${trendIcon}`}></i>
                {trend.value}%
              </span>
            )}
            {average && (
              <span className="kpi-average">Avg: {average}</span>
            )}
            {period && (
              <span className="kpi-period">{period}</span>
            )}
          </div>
        </div>
        {icon && (
          <div className="kpi-icon-wrap" aria-hidden="true">
            <div className="kpi-icon">
              <i className={`bi ${icon}`}></i>
            </div>
          </div>
        )}
        {largeIcon && (
          <div className="kpi-large-icon" aria-hidden="true">
            <i className={`bi ${largeIcon}`}></i>
          </div>
        )}
      </div>
      {footerLink && (
        <div className="card-footer">
          <a href={footerLink.href} className="kpi-footer-link">
            {footerLink.text} <i className="bi bi-arrow-right"></i>
          </a>
        </div>
      )}
    </div>
  );
}
